if (!window.__MARGALO_CART_PREMIUM_LOADED__) {
  window.__MARGALO_CART_PREMIUM_LOADED__ = true;

  (() => {
    const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
    let busy = false;

    const copy = isGerman
      ? {
          promo: '2 KAUFEN + 1 GRATIS',
          unlocked: 'ANGEBOT FREIGESCHALTET',
          addOne: 'Noch 1 Artikel hinzufügen und das Angebot freischalten.',
          addTwo: 'Noch 2 Artikel hinzufügen und das Angebot freischalten.',
          addThree: '3 teilnehmende Artikel wählen — der günstigste wird automatisch rabattiert.',
          complete: 'Dein 2+1-Gratis-Vorteil ist aktiv.',
          look: 'COMPLETE THE LOOK',
          lookSub: 'Uhren & Schmuck zu deiner Auswahl.',
          swipe: 'Nach rechts wischen →',
          add: 'HINZUFÜGEN',
          adding: 'WIRD HINZUGEFÜGT…',
          added: 'HINZUGEFÜGT ✓',
        }
      : {
          promo: 'BUY 2 GET 1 FREE',
          unlocked: 'OFFER UNLOCKED',
          addOne: 'Add 1 more item to unlock the offer.',
          addTwo: 'Add 2 more items to unlock the offer.',
          addThree: 'Choose 3 eligible items — the lowest-priced one is discounted automatically.',
          complete: 'Your Buy 2 Get 1 Free offer is active.',
          look: 'COMPLETE THE LOOK',
          lookSub: 'Pieces that pair well with your selection.',
          swipe: 'Swipe for more →',
          add: 'ADD TO CART',
          adding: 'ADDING…',
          added: 'ADDED ✓',
        };

    const money = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      }).format(cents / 100);

    async function getCart() {
      const response = await fetch(`${ROOT}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
      return response.json();
    }

    function eligibleWatchCount(cart) {
      return (cart.items || []).reduce((count, item) => {
        const title = item.product_title || '';
        const isTool = /watch[ -]?link[ -]?remover/i.test(title) || item.properties?._margalo_free_watch_tool === '1';
        return isTool ? count : count + Number(item.quantity || 0);
      }, 0);
    }

    function offerMarkup(cart, compact = false) {
      const count = eligibleWatchCount(cart);
      const completed = count >= 3;
      const steps = Math.min(count, 3);
      let message = copy.addThree;
      if (count === 1) message = copy.addTwo;
      if (count === 2) message = copy.addOne;
      if (completed) message = copy.complete;

      return `<section class="mc-cart-offer${compact ? ' mc-cart-offer--drawer' : ''}${completed ? ' is-complete' : ''}" data-mc-offer>
        <div class="mc-cart-offer__top"><span>${copy.promo}</span><strong>${completed ? copy.unlocked : `${steps}/3`}</strong></div>
        <div class="mc-cart-offer__progress" aria-hidden="true"><i class="${steps >= 1 ? 'is-on' : ''}"></i><i class="${steps >= 2 ? 'is-on' : ''}"></i><i class="${steps >= 3 ? 'is-on' : ''}"></i></div>
        <p>${message}</p>
      </section>`;
    }

    async function recommendationMarkup(cart) {
      if (!cart.items || !cart.items.length) return '';
      try {
        const collectionHandles = ['uhr-herren', 'armband-herren', 'halsketten-herren', 'accessories'];
        const cartProductIds = new Set(cart.items.map((item) => Number(item.product_id)));
        const groups = await Promise.all(collectionHandles.map(async (handle) => {
          try {
            const response = await fetch(`${ROOT}collections/${handle}/products.json?limit=250`, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) return [];
            const data = await response.json();
            return (data.products || [])
              .filter((product) => !cartProductIds.has(Number(product.id)))
              .filter((product) => !/watch[ -]?(?:link[ -]?remover|tool)/i.test(product.title || ''))
              .filter((product) => (product.variants || []).some((variant) => variant.available));
          } catch (error) {
            return [];
          }
        }));
        const selectedIds = new Set();
        const items = groups.flatMap((products) => {
          const candidates = products.filter((product) => !selectedIds.has(Number(product.id)));
          if (!candidates.length) return [];
          const product = candidates[Math.floor(Math.random() * candidates.length)];
          selectedIds.add(Number(product.id));
          const variant = product.variants.find((item) => item.available);
          return [{
            ...product,
            url: `${ROOT}products/${encodeURIComponent(product.handle)}`,
            price: Math.round(Number(variant.price) * 100),
            featured_image: product.images?.[0]?.src || '',
          }];
        });
        if (!items.length) return '';

        const cards = items.map((product) => {
          const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
          if (!variant) return '';
          const image = product.featured_image || (product.images && product.images[0]) || '';
          const title = String(product.title || '').replace(/[&<>"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[char]));
          return `<article class="mc-cart-rec">
            <a class="mc-cart-rec__media" href="${product.url || '#'}"><img src="${image}" alt="${title}" loading="lazy"></a>
            <div class="mc-cart-rec__body">
              <a href="${product.url || '#'}" class="mc-cart-rec__title">${title}</a>
              <span class="mc-cart-rec__price">${money(product.price)}</span>
              <button type="button" class="mc-cart-rec__add" data-mc-add="${variant.id}">${copy.add}</button>
            </div>
          </article>`;
        }).join('');

        return `<section class="mc-cart-recs mc-cart-recs--drawer" data-mc-recs>
          <div class="mc-cart-recs__head"><span>${copy.look}</span><small>${copy.lookSub}</small>${items.length > 1 ? `<small class="mc-cart-recs__swipe">${copy.swipe}</small>` : ''}</div>
          <div class="mc-cart-recs__grid">${cards}</div>
        </section>`;
      } catch (error) {
        return '';
      }
    }

    async function enhance() {
      if (busy) return;
      busy = true;
      try {
        const cart = await getCart();
        if (!cart.items || !cart.items.length) return;

        const drawerItems = document.querySelector('.cart-drawer__items');
        if (drawerItems) {
          drawerItems.querySelectorAll('[data-mc-offer], [data-mc-recs]').forEach((node) => node.remove());
          drawerItems.insertAdjacentHTML('afterbegin', offerMarkup(cart, true));
          const recs = await recommendationMarkup(cart);
          if (recs) drawerItems.insertAdjacentHTML('beforeend', recs);
        }

        const cartPage = document.querySelector('.cart-page');
        const cartPageItems = cartPage && cartPage.querySelector('.cart-page__items');
        if (cartPage && cartPageItems) {
          cartPage.querySelectorAll('[data-mc-offer]').forEach((node) => node.remove());
          cartPageItems.insertAdjacentHTML('beforebegin', offerMarkup(cart, false));
        }
      } finally {
        busy = false;
      }
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-mc-add]');
      if (!button) return;
      event.preventDefault();
      if (button.disabled) return;

      button.disabled = true;
      const oldText = button.textContent;
      button.textContent = copy.adding;

      try {
        const response = await fetch(`${ROOT}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(button.dataset.mcAdd), quantity: 1 }),
        });
        if (!response.ok) throw new Error('Add failed');
        button.textContent = copy.added;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.setTimeout(() => window.location.reload(), 220);
      } catch (error) {
        button.disabled = false;
        button.textContent = oldText;
      }
    });

    const scheduleEnhance = () => {
      window.clearTimeout(window.__mcCartTimer);
      window.__mcCartTimer = window.setTimeout(enhance, 120);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
    else enhance();
    document.addEventListener('cart:update', scheduleEnhance);
    document.addEventListener('cart:updated', scheduleEnhance);
    document.addEventListener('cart:refresh', scheduleEnhance);
  })();
}
